import { IBasicReportView, IJob } from '../markout.interface';

// The API returns a report's jobs newest-first, so the array index is not a
// reliable way to find the most recent job. Pick the job with the greatest
// startedAt instead.
export const getLatestJob = (report: IBasicReportView): IJob | null => {
  if (report.jobs.length === 0) {
    return null;
  }
  return report.jobs.reduce((latest, candidate) => (
    candidate.startedAt > latest.startedAt ? candidate : latest
  ));
};
